import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@tkww/the-bash-frontend';

import { CONFETTI_HERO_IMAGE_LEFT, CONFETTI_HERO_IMAGE_RIGHT } from 'constants/heros';
import SectionContainer from 'components/grid/SectionContainer';

const StyledTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasSubtitle',
})(({ theme, hasSubtitle }) => ({
  marginTop: 0,
  marginBottom: hasSubtitle ? 'revert' : 0,
  [theme.breakpoints.down('md')]: {
    maxWidth: 275,
  },
}));

const StyledSubTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  maxWidth: 275,
  [theme.breakpoints.up('md')]: {
    maxWidth: 531,
  },
  [theme.breakpoints.up('xl')]: {
    maxWidth: 731,
  },
}));

const StyledImage = styled('div')(({ theme }) => ({
  position: 'absolute',
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundSize: 'cover',
  minWidth: '40px',
  width: '15%',
  [theme.breakpoints.up('md')]: {
    width: '20%',
  },
  height: '100%',
}));

const StyledLeftImage = styled(StyledImage)(() => ({
  backgroundPositionX: 'right',
  backgroundPositionY: 'bottom',
  backgroundImage: `url(${CONFETTI_HERO_IMAGE_LEFT})`,
}));

const StyledRightImage = styled(StyledImage)(() => ({
  backgroundImage: `url(${CONFETTI_HERO_IMAGE_RIGHT})`,
  right: 0,
}));

const HeroWithConfetti = ({ title, subtitle, solidBackground, backgroundColor, large }) => {
  const theme = useTheme();
  const additionalProps = {};

  if (!solidBackground) {
    additionalProps.leftContent = <StyledLeftImage />;
    additionalProps.rightContent = <StyledRightImage />;
  }

  return (
    <SectionContainer
      containerProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: large ? 4 : null,
        },
      }}
      sx={{
        display: 'flex',
        width: '100%',
        height: large ? { xs: 313, md: 217 } : '100%',
        minHeight: 178,
        position: 'relative',
      }}
      backgroundColor={backgroundColor || theme.palette.citrine[50]}
      {...additionalProps}
    >
      <StyledTitle variant="h1" align="center" hasSubtitle={!!subtitle}>
        {title}
      </StyledTitle>
      {subtitle && (
        <StyledSubTitle variant="body1" align="center">
          {subtitle}
        </StyledSubTitle>
      )}
    </SectionContainer>
  );
};

HeroWithConfetti.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  solidBackground: PropTypes.bool,
  backgroundColor: PropTypes.string,
  large: PropTypes.bool,
};

HeroWithConfetti.defaultProps = {
  subtitle: null,
  solidBackground: false,
  backgroundColor: '',
  isLarge: false,
};

export default HeroWithConfetti;
